import { Icon, Values } from '@graftcode/design-system'

export const PACKAGE_MANAGER_ICON: Values<typeof Icon> = Icon.BoxRegular
